// Mobile CRM design preview — renders the raw Claude Design canvas at
// /design/mobile-crm so admin can review variations A & B in their CRM
// before committing to an implementation. Pure preview; no data wiring.

import { useNavigate } from "react-router-dom";
import { ArrowLeft, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const DESIGN_URL = "/design/dnexus-mobile-crm.html";

export default function MobileCrmDesignPreview() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-900 -mx-4 -my-4 md:-mx-8 md:-my-6 lg:-mx-8 lg:-my-8 p-0 flex flex-col" data-testid="mobile-crm-design-preview">
      <header className="sticky top-0 z-10 bg-slate-900/95 backdrop-blur border-b border-slate-700/50 px-4 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <Button
            size="sm"
            variant="ghost"
            onClick={() => navigate(-1)}
            className="text-white hover:bg-slate-800"
            data-testid="design-preview-back"
          >
            <ArrowLeft className="w-4 h-4 mr-1" /> Back
          </Button>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-white truncate">Mobile CRM Design Preview</p>
            <p className="text-[11px] text-slate-400 truncate">Variation A · Vibrant + Variation B · Refined — scroll right to compare</p>
          </div>
        </div>
        <Button
          size="sm"
          variant="outline"
          onClick={() => window.open(DESIGN_URL, "_blank")}
          className="border-slate-600 text-white hover:bg-slate-800"
        >
          <ExternalLink className="w-3.5 h-3.5 mr-1" /> Open full
        </Button>
      </header>
      <iframe
        src={DESIGN_URL}
        title="Dnexus Mobile CRM Design"
        className="flex-1 w-full border-0 bg-slate-900"
        style={{ minHeight: "calc(100vh - 60px)" }}
      />
    </div>
  );
}
